<div class="success-dialog">
    @if (data.stackSubmessage && data.submessage) {
        <div class="success-dialog__content success-dialog__content--stacked-sub">
            <z-icon zType="circle-check" class="success-dialog__icon" />
            <p class="success-dialog__message">{{ data.title || data.message }}</p>
            <p class="success-dialog__submessage">{{ data.submessage }}</p>
        </div>
    } @else {
        <div class="success-dialog__content">
            <z-icon zType="circle-check" class="success-dialog__icon" />
            <div class="success-dialog__text">
                <p class="success-dialog__message">{{ data.title || data.message }}</p>
                @if (data.submessage) {
                    <p class="success-dialog__submessage">{{ data.submessage }}</p>
                }
            </div>
        </div>
    }
    <footer class="success-dialog__footer">
        @if (data.viewText) {
            <button
                type="button"
                z-button
                zType="outline"
                zSize="default"
                class="success-dialog__btn success-dialog__btn--secondary"
                (click)="handleCloseClick()"
            >
                {{ data.closeText || 'Close' }}
            </button>
            <button
                type="button"
                z-button
                zType="default"
                zSize="default"
                class="success-dialog__btn success-dialog__btn--primary"
                (click)="handleViewClick()"
            >
                {{ data.viewText }}
            </button>
        } @else {
            <button
                type="button"
                z-button
                zType="default"
                zSize="default"
                class="success-dialog__btn success-dialog__btn--primary"
                (click)="handleConfirmClick()"
            >
                {{ data.confirmText || defaultTexts.SUCCESS.confirmText }}
            </button>
        }
    </footer>
</div>
